











import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import ChartStancePhaseAverageStepSequence from '@/components/charts/ChartStancePhaseAverageStepSequence.vue';

@Component({
  components: { ChartStancePhaseAverageStepSequence },
})
export default class PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageStepSequence extends Vue {
  @Prop({ required: true }) private patientId!: TEntity<TPatient>['_id'];
  @Prop({ required: true }) private acquisitionId!: TEntity<TAcquisition['_id']>;
  @Prop({ required: true }) private height!: number;

  get patient() {
    return this.$pdc.entities!.patients.getStoredEntityById(this.patientId);
  }

  get acquisition() {
    return this.$pdc.entities!.patients.getAcquisitionById(this.patientId, this.acquisitionId);
  }
}
